import ProductForm from "./ProductForm";
import compose from "recompose/compose";
import mapProps from "recompose/mapProps";
import withState from "recompose/withState";
import withHandlers from "recompose/withHandlers";
import { connect } from "react-redux";
import { fetchPrismicProduct } from "src/client/js/store/thunks/prismic/product";
import { getPrismicProduct } from "src/client/js/store/selectors/prismic/product";
import withCountry from "../../hocs/withCountry";
import { setCloseOverlay, setOpenOverlay } from "../../../store/actions/app";
import withMediaQueries from "../../hocs/withMediaQueries";
import { withModel } from "../../data-providers/model";

const enhance = compose(
  withModel,
  connect(
    (state, props) => ({
      prismicProductLangs: getPrismicProduct(state, props.primary.productId),
    }),
    null
  ),
  connect(null, (dispatch, props) => ({
    fetchPrismicProduct: (sku, locale) =>
      dispatch(fetchPrismicProduct(sku, locale, props)),
    openOverlay: (scrollPos) => dispatch(setOpenOverlay(scrollPos)),
    closeOverlay: () => dispatch(setCloseOverlay()),
  })),
  mapProps((props) => ({
    productId: props.primary.product.main.productId,
    form: props.primary.product.form,
    size: props.primary.size,
    id: props.id,
    fetchPrismicProduct: props.fetchPrismicProduct,
    openOverlay: props.openOverlay,
    closeOverlay: props.closeOverlay,
  })),
  withCountry,
  withState("isMultiAdventurerOpen", "setMultiAdventurerOpen", false),
  withMediaQueries,
  withHandlers({
    handleMultiAdventurerToggle: (props) => (event) => {
      if (!props.isMultiAdventurerOpen && props.media.fabletDown) {
        props.openOverlay(window.scrollY);
      } else {
        props.closeOverlay();
      }
      props.setMultiAdventurerOpen((state) => !state);
      event.target.blur();
    },
  })
);

export default enhance(ProductForm);
